export default __webpack_public_path__ + "static/California-ac46a7a6e205e5e5e8c41814ddda286a.webp";